import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  private messageService: MessageService = inject(MessageService);
  constructor(private router: Router) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    request = request.clone({
      withCredentials: true,
    });

    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        const status = err.status;
        const customError = err.error;

        if (
          status === HttpStatusCode.Unauthorized ||
          status === HttpStatusCode.Forbidden
        ) {
          this.router.navigate(['/login']);
        }
        console.log(customError);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: customError.message,
        });

        return throwError(() => err);
      })
    );
  }
}
